module.exports = __webpack_public_path__ + "img/guifan4.1f34f2eb.jpg";